import { isCommunityUrl } from './community-route.util';

/**
 * Whether the network layout (ic-main) shows the site footer. Hidden only where the page fills the
 * screen itself: the native app, community pages and event sub-pages (rooms, tickets, expo).
 * Album, video and playlist pages show it; the footer keeps room for the music player itself.
 */
export function showsSiteFooter(url: string | null | undefined, appType: string | null | undefined): boolean {
  const path = (url || '').split('?')[0];
  return appType !== 'native' && !isCommunityUrl(path) && !path.includes('/event/');
}
